import { useEffect } from 'react';

const NewsletterSignup = () => {
  useEffect(() => {
    // Load Mailchimp validation script
    const script = document.createElement('script');
    script.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
    script.async = true;
    document.body.appendChild(script);

    // Initialize Mailchimp validation after script loads
    script.onload = () => {
      if (window.fnames && window.ftypes) {
        window.fnames = new Array();
        window.ftypes = new Array();
        window.fnames[0] = 'EMAIL';
        window.ftypes[0] = 'email';
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="newsletter-signup">
      <div id="mc_embed_signup">
        <form
          action="https://pattawi.us22.list-manage.com/subscribe/post?u=d0c4242935e0654e4594038dc&amp;id=e2f3907e33&amp;f_id=0002e1e1f0"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          target="_blank"
        >
          <div id="mc_embed_signup_scroll">
            <div className="mc-field-group">
              <label htmlFor="mce-EMAIL">
                Email Address <span className="asterisk">*</span>
              </label>
              <input
                type="email"
                name="EMAIL"
                className="required email"
                id="mce-EMAIL"
                required
                placeholder="your@email.com"
              />
            </div>
            
            <div id="mce-responses" className="clear">
              <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
              <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
            </div>
            
            {/* Bot prevention */}
            <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
              <input
                type="text"
                name="b_d0c4242935e0654e4594038dc_e2f3907e33"
                tabIndex="-1"
                defaultValue=""
              />
            </div>
            
            <div className="clear">
              <input
                type="submit"
                name="subscribe"
                id="mc-embedded-subscribe"
                className="button"
                value="Subscribe"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewsletterSignup;
